var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.50833 9.35V13.0917C2.50833 16.8333 4.00833 18.3333 7.75 18.3333H12.2417C15.9833 18.3333 17.4833 16.8333 17.4833 13.0917V9.35",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 10C11.525 10 12.65 8.75833 12.5 7.23333L11.95 1.66667H8.05833L7.5 7.23333C7.35 8.75833 8.475 10 10 10Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.2583 10C16.9417 10 18.175 8.63333 18.0083 6.95833L17.775 4.66667C17.475 2.5 16.6417 1.66667 14.4583 1.66667H11.9167L12.5 7.50833C12.6417 8.88333 13.8833 10 15.2583 10Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.7 10C6.075 10 7.31667 8.88333 7.45 7.50833L7.63333 5.66667L8.03333 1.66667H5.49167C3.30833 1.66667 2.475 2.5 2.175 4.66667L1.95 6.95833C1.78333 8.63333 3.01667 10 4.7 10Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10 14.1667C8.60833 14.1667 7.91667 14.8583 7.91667 16.25V18.3333H12.0833V16.25C12.0833 14.8583 11.3917 14.1667 10 14.1667Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopLinear);
export default __webpack_public_path__ + "static/media/shop-linear.7ce9ca5e551bb6b9649aa939031d0ae5.svg";
export { ForwardRef as ReactComponent };